import { call, delay, put, select, take, race } from "redux-saga/effects";
import { logoutUser } from "actions/userActions";
import AppsmithConsole from "utils/AppsmithConsole";
import { getCurrentApplication } from "selectors/editorSelectors";
import type { PageWidgetsReduxState } from "reducers/uiReducers/pageWidgetsReducer";
import { getPageWidgets, getAppData } from "ce/selectors/entitiesSelector";
import { getWidgetsMeta } from "sagas/selectors";
import type { CurrentPageDraftReduxState } from "reducers/uiReducers/pageDraftReducer";
import { getPageDraftDsl } from "ce/selectors/entitiesSelector";
import { currentPageId as getCurrentPageId } from "sagas/selectors";
import {
  savePageDraftAction,
  deleteDraftAction,
  restoreDraftAction,
  getPageDraftAction,
} from "actions/draftActions";
import { getAppMode } from "selectors/applicationSelectors";
import { APP_MODE } from "entities/App";
import { message } from "antd";
import { fetchPublishedPageSaga } from "ee/sagas/PageSagas";
import { fetchPublishedPage } from "actions/pageActions";
import { getPageDraftSaga } from "ee/sagas/draftSages";
import { validateResponse } from "sagas/ErrorSagas";
import type { ApiResponse } from "api/ApiResponses";
import DraftApi from "api/DraftApi";
import {
  ReduxActionTypes,
  WidgetReduxActionTypes,
  type ReduxAction,
} from "ee/constants/ReduxActionConstants";
import resetWidget from "workers/Evaluation/fns/resetWidget";
import store from "store";
import { isEmpty } from "lodash";
import { resetWidgetsMetaState, resetWidgetsMeta } from "actions/metaActions";
import type { WidgetProps } from "widgets/BaseWidget";

  const draftType: string[] = [
    // normal
    "INPUT_WIDGET_V2",
    "PHONE_INPUT_WIDGET",
    "CURRENCY_INPUT_WIDGET",
    "RICH_TEXT_EDITOR_WIDGET",
    "CHECKBOX_WIDGET",
    "CHECKBOX_GROUP_WIDGET",
    "RADIO_GROUP_WIDGET",
    "RATE_WIDGET",
    "SELECT_WIDGET",
    "MULTI_SELECT_WIDGET_V2",
    "SINGLE_SELECT_TREE_WIDGET",
    "MULTI_SELECT_TREE_WIDGET",
    "SWITCH_WIDGET",
    "DATE_PICKER_WIDGET2",
    // antd
    "ANTD_SELECT_WIDGET",
    "ANTD_MULTI_SELECT_WIDGET_V2",
    "ANTD_SINGLE_SELECT_TREE_WIDGET",
    "ANTD_MULTI_SELECT_TREE_WIDGET",
    "ANTD_SWITCH_WIDGET",
    "ANTD_SEGMENTED_WIDGET",
    "ANTD_RADIO_GROUP_WIDGET",
    "ANTDDATERANGEPICKER_WIDGET",
    "ANTDDATEPICKER_WIDGET",
    "ANTDTIMERANGEPICKER_WIDGET",
    "ANTDTIMEPICKER_WIDGET",
  ];

export function* saveDraftActionSaga(action: any) {
  const PageDraft: CurrentPageDraftReduxState = yield select(getPageDraftDsl);
  const currentPageId: string = yield select(getCurrentPageId);
  const metaProps: Record<string, unknown> = yield select(getWidgetsMeta);
  const mode: APP_MODE = yield select(getAppMode);
  const currentPageDraftDsl = PageDraft[currentPageId].dsl;


  console.log("currentPageDraft", currentPageDraftDsl, metaProps);
  if (mode === APP_MODE.EDIT) {
    message.warning("请发布应用后使用草稿相关功能");
    return;
  }
  const newDsl = injectSelectedOptionValue(
    currentPageDraftDsl,
    draftType,
    metaProps,
  );
  yield put(
    savePageDraftAction({
      pageId: currentPageId,
      dsl: newDsl,
    }),
  );
  yield delay(1000); // 延迟 1 秒
  // yield put(fetchPublishedPage(currentPageId, true, false, undefined, true));
}

export function* fetchPageDraftWorker(
  pageId: string,
): Generator<any, any, any> {
  try {
    const response: ApiResponse = yield call(DraftApi.getPageDraft, pageId);
    const isValidResponse: boolean = yield validateResponse(response);

    if (isValidResponse) {
      return response?.data;
    }
  } catch (error) {
    console.log(error);
  }
  return null;
}

export function* restoreDraftActionSaga(action: any): Generator<any, any, any> {
  const currentPageId: string = yield select(getCurrentPageId);
  const mode: APP_MODE = yield select(getAppMode);
  
  if (mode === APP_MODE.EDIT) {
    message.warning("请发布应用后使用草稿相关功能");
    return;
  }

  const draftData = yield call(fetchPageDraftWorker, currentPageId);

  if (!draftData) {
    message.error("当前页面找不到草稿");
    return;
  }

  yield put(
    restoreDraftAction({
      pageId: currentPageId,
    }),
  );
  // const state = store.getState();
  // const currentPageWidgets = state.entities.canvasWidgets;
  // if (!isEmpty(currentPageWidgets)) {
  // const staleMetaIds = Object.keys(currentPageWidgets).filter((widgetId) => {
  //   const widget = currentPageWidgets[widgetId];
  //   return draftType.includes(widget?.type);
  // });
  // // debugger;
  // yield put(resetWidgetsMetaState(staleMetaIds));
  // yield put(resetWidgetsMeta());
  // const currentPageWidgetsArray = Object.values(currentPageWidgets);
  // // for (const widget of currentPageWidgetsArray as WidgetProps[]) {
  // //   yield put({
  // //     type: WidgetReduxActionTypes.WIDGET_DELETE,
  // //     payload: {
  // //       widgetId: widget?.widgetId,
  // //       parentId: widget?.parentId,
  // //     },
  // //   });
  // // }
  // }
  yield call(() => new Promise((resolve) => setTimeout(resolve, 1000))); // 延迟 1 秒
  window.location.reload();
  // 
  // yield put(fetchPublishedPage(currentPageId, true, false, undefined, true));
}

export function* deleteDraftActionSaga(action: any): Generator<any, any, any> {
  const currentPageId: string = yield select(getCurrentPageId);
  const mode: APP_MODE = yield select(getAppMode);
  if (mode === APP_MODE.EDIT) {
    message.warning("请发布应用后使用草稿相关功能");
    return;
  }
  const draftData = yield call(fetchPageDraftWorker, currentPageId);

  if (!draftData) {
    message.error("当前页面找不到草稿");
    return;
  }
  yield put(
    deleteDraftAction({
      pageId: currentPageId,
    }),
  );
  // const state = store.getState();
  // const currentPageWidgets = state.entities.canvasWidgets;
  // if (!isEmpty(currentPageWidgets)) {
  // const staleMetaIds = Object.keys(currentPageWidgets).filter((widgetId) => {
  //   const widget = currentPageWidgets[widgetId];
  //   return draftType.includes(widget?.type);
  // });
  // // debugger;
  // yield put(resetWidgetsMetaState(staleMetaIds));
  // // const currentPageWidgetsArray = Object.values(currentPageWidgets);
  // //   currentPageWidgetsArray.forEach((widget: { type: string; widgetName: string }) => {
  // //     if (draftType.includes(widget?.type)) {
  // //       resetWidget(widget?.widgetName, true, "", "", "debounce", 1000);
  // //     }
  // //   });
  // }
  yield delay(1000); // 延迟 1 秒
  // yield put(fetchPublishedPage(currentPageId, true, false, undefined, false));
  window.location.reload();
}

const typeMetaMap: Record<string, { metaKey: string; targetKey: string }> = {
  INPUT_WIDGET_V2: { metaKey: "text", targetKey: "defaultText" },
  PHONE_INPUT_WIDGET: { metaKey: "value", targetKey: "defaultText" },
  CURRENCY_INPUT_WIDGET: { metaKey: "text", targetKey: "defaultText" },
  RICH_TEXT_EDITOR_WIDGET: { metaKey: "text", targetKey: "defaultText" },
  CHECKBOX_WIDGET: { metaKey: "isChecked", targetKey: "defaultCheckedState" },
  CHECKBOX_GROUP_WIDGET: {
    metaKey: "selectedValues",
    targetKey: "defaultSelectedValues",
  },
  RADIO_GROUP_WIDGET: {
    metaKey: "selectedOptionValue",
    targetKey: "defaultOptionValue",
  },
  RATE_WIDGET: { metaKey: "rate", targetKey: "defaultRate" },
  SELECT_WIDGET: { metaKey: "value", targetKey: "defaultOptionValue" },
  MULTI_SELECT_WIDGET_V2: {
    metaKey: "selectedOptions",
    targetKey: "defaultOptionValue",
  },
  SINGLE_SELECT_TREE_WIDGET: {
    metaKey: "selectedOption",
    targetKey: "defaultOptionValue",
  },
  MULTI_SELECT_TREE_WIDGET: {
    metaKey: "selectedOptionValueArr",
    targetKey: "defaultOptionValue",
  },
  SWITCH_WIDGET: { metaKey: "isSwitchedOn", targetKey: "defaultSwitchState" },
  DATE_PICKER_WIDGET2: { metaKey: "value", targetKey: "defaultDate" },
  // antd
  ANTD_SELECT_WIDGET: { metaKey: "value", targetKey: "defaultOptionValue" },
  ANTD_MULTI_SELECT_WIDGET_V2: {
    metaKey: "selectedOptions",
    targetKey: "defaultOptionValue",
  },
  ANTD_SINGLE_SELECT_TREE_WIDGET: {
    metaKey: "selectedOption",
    targetKey: "defaultOptionValue",
  },
  ANTD_MULTI_SELECT_TREE_WIDGET: {
    metaKey: "selectedOptionValueArr",
    targetKey: "defaultOptionValue",
  },
  ANTD_SWITCH_WIDGET: {
    metaKey: "isSwitchedOn",
    targetKey: "defaultSwitchState",
  },
  ANTD_SEGMENTED_WIDGET: {
    metaKey: "selectedOptionValue",
    targetKey: "defaultOptionValue",
  },
  ANTD_RADIO_GROUP_WIDGET: {
    metaKey: "selectedOptionValue",
    targetKey: "defaultOptionValue",
  },
  ANTDDATERANGEPICKER_WIDGET: { metaKey: "value", targetKey: "defaultValue" },
  ANTDDATEPICKER_WIDGET: { metaKey: "value", targetKey: "defaultValue" },
  ANTDTIMERANGEPICKER_WIDGET: { metaKey: "value", targetKey: "defaultValue" },
  ANTDTIMEPICKER_WIDGET: { metaKey: "value", targetKey: "defaultValue" },
};

function injectSelectedOptionValue(
  node: any,
  draftType: string[],
  metaProps: Record<string, any>,
) {
  const newNode = { ...node };
  const meta = metaProps[newNode.widgetId];
  if (draftType.includes(newNode.type) && meta) {
    const config = typeMetaMap[newNode.type];
    if (config && meta[config.metaKey] !== undefined) {
      switch (newNode.type) {
        case "CURRENCY_INPUT_WIDGET":
          newNode[config.targetKey] = meta[config.metaKey].replaceAll(",", "");
          break;
        case "MULTI_SELECT_WIDGET_V2":
          newNode[config.targetKey] = meta[config.metaKey].map(
            (item: any) => item.value,
          );
          break;
        // case "ANTDDATERANGEPICKER_WIDGET":
        //   newNode["defaultValueStart"] = meta[config.metaKey][0];
        //   newNode["defaultValueEnd"] = meta[config.metaKey][1];
        //   break;
        default:
          newNode[config.targetKey] = meta[config.metaKey];
      }
    }
  }

  if (Array.isArray(newNode.children)) {
    newNode.children = newNode.children.map((child: any) =>
      injectSelectedOptionValue(child, draftType, metaProps),
    );
  }

  return newNode;
}
